module.exports = require('./helpers/bundle-url').getBundleURL('51kHd') + "logo-dark.eefe0b7f.svg";